/**
 * Functions to help with accessibility related things
 */

/**
 * Wraps a click handler function so that it can be passed to onKeyPress as
 * well to handle when the enter key is pressed
 *
 * @example
 * import { buildHandleEnterKeyPress } from 'utils/a11y'
 *
 * <span
 *   tabIndex="0"
 *   role="button"
 *   onClick={handleClick}
 *   onKeyPress={buildHandleEnterKeyPress(handleClick)}
 * >
 *   Push my button
 * </span>
 */
export const buildHandleEnterKeyPress =
  onClick =>
  ({ key }) => {
    if (key === 'Enter') {
      onClick();
    }
  };
